import httpClient from '@/apis/base/httpclient';
import BaseAPI from '@/apis/base/baseApi';
import webSocket from '@/sockets/socket';

class RequestAPI extends BaseAPI {
  constructor() {
    super();
  }

  apiName = 'Business';
  controllerName = 'Requests';

  //Đường dẫn api
  getRequestByFilter = 'list-request';
  rejectRequests = 'reject';

  //danh sách request
  listLicense = 'list-license';

  listRequestApprove = 'list-request-approve';
  createdRequest = 'employee-created';

  // Parent-Child Request endpoints
  multiBranchRequest = 'multi-branch';
  parentRequestDetail = 'parent';

  /**
   * Lấy danh sách request có filter
   */
  async getListRequest(model, loading = true) {
    let request = {
      url: [this.getAPIUrl(), this.getRequestByFilter].join('/'),
      data: model,
    };
    var res = httpClient.postAsync(request, loading);
    return res;
  }

  /**
   * Lấy danh sách request có filter
   */
  async getListRequestNeedApprove(model, loading = true) {
    let request = {
      url: [this.getAPIUrl(), this.listRequestApprove].join('/'),
      data: model,
    };
    var res = httpClient.postAsync(request, loading);
    return res;
  }

  /**
   * Approve & Reject request
   */
  async rejectRequest(model) {
    let request = {
      url: [this.getAPIUrl(), this.rejectRequests].join('/'),
      data: model,
    };

    var res = httpClient.postAsync(request);

    return res;
  }

  async getEmployeeCreatedRequest() {
    let request = {
      url: [this.getAPIUrl(), this.createdRequest].join('/'),
    };

    var res = httpClient.getAsync(request);

    return res;
  }

  /**
   * Tạo multi-branch request cho nhiều chi nhánh
   * Created by: hbviet
   * Created date: 14/07/2025
   */
  async createMultiBranchRequest(payload, loading = true) {
    let request = {
      url: [this.getAPIUrl(), this.multiBranchRequest].join('/'),
      data: payload,
    };

    var res = httpClient.postAsync(request, loading);
    return res;
  }

  /**
   * Lấy chi tiết parent request với children
   * Created by: hbviet
   * Created date: 14/07/2025
   */
  async getParentRequestDetail(parentId, loading = true) {
    let request = {
      url: [this.getAPIUrl(), this.parentRequestDetail, parentId].join('/'),
    };

    var res = httpClient.getAsync(request, loading);
    return res;
  }

  /**
   * Lấy danh sách children của parent request
   * Created by: hbviet
   * Created date: 14/07/2025
   */
  async getRequestChildren(parentId, loading = true) {
    let request = {
      url: [this.getAPIUrl(), this.parentRequestDetail, parentId, 'children'].join('/'),
    };

    var res = httpClient.getAsync(request, loading);
    return res;
  }

  /**
   * Update parent status sau khi child status thay đổi
   * Created by: hbviet
   * Created date: 14/07/2025
   */
  async updateParentStatus(parentId, loading = true) {
    let request = {
      url: [this.getAPIUrl(), this.parentRequestDetail, parentId, 'status'].join('/'),
    };

    var res = httpClient.putAsync(request, loading);
    return res;
  }

  /**
   * Approve multiple requests (parent and children)
   * Created by: hbviet
   * Created date: 15/01/2025
   */
  async approveMultipleRequests(parameters, loading = true) {
    let request = {
      url: [this.getAPIUrl(), 'approve-multi'].join('/'),
      data: parameters,
    };

    var res = httpClient.postAsync(request, loading);
    return res;
  }

  /**
   * Reject multiple requests (parent and children)
   * Created by: hbviet
   * Created date: 15/01/2025
   */
  async rejectMultipleRequests(parameters, loading = true) {
    let request = {
      url: [this.getAPIUrl(), 'reject-multi'].join('/'),
      data: parameters,
    };

    var res = httpClient.postAsync(request, loading);
    return res;
  }

  /**
   * Description: Lấy thông tin company cho form LicenseInfo
   * Created by: hbviet
   * Created date: 21/01/2025
   */
  async getCompanyInfo(companyCode, loading = true) {
    let request = {
      url: [this.getAPIUrl(), 'company-info', companyCode].join('/'),
    };

    var res = httpClient.getAsync(request, loading);
    return res;
  }

  /**
   * Tạo đường dẫn đăng nhập be
   * @param {*} company_name
   * @param {*} domain
   * @returns
   */
  async createQuickLoginUrl(company_code, domain) {
    let request = {
      url: [this.getAPIUrl(), 'quick-login-url'].join('/'),
      data: {
        domain,
        company_code,
      },
    };

    var res = httpClient.postAsync(request);

    return res;
  }
}

export default new RequestAPI();
